import * as reactIntl from 'react-intl';

import { yup } from '»utils/form';

export const legalPersonFormValidation = (mainFormFields) => {
  const intl = reactIntl.useIntl();

  const requiredFieldMessage = intl.formatMessage({
    id: 'TRLT_UI-REQUIRED_FIELD',
  });

  const fieldMustBeNumber = intl.formatMessage({
    id: 'TRLT_UI-NUMBER_FIELD',
  });

  const fieldMustBeEmail = intl.formatMessage({
    id: 'TRLT_UI-INVALID_EMAIL',
  });

  const fieldMustBeIntegerPercentage = intl.formatMessage({
    id: 'TRLT_UI-INTEGER_PERCENTAGE_FIELD',
  });

  const fieldCanNotHaveSpaces = intl.formatMessage({
    id: 'TRLT_UI-NO_SPACES_ALLOW',
  });

  const getFieldObligation = (fieldName) =>
    mainFormFields.find((field) => field.name === fieldName)?.isRequired;

  return yup.object().shape({
    companyName: yup.string().when([], {
      is: () => getFieldObligation('companyName'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    denomination: yup.string().when([], {
      is: () => getFieldObligation('denomination'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    constitutionDate: yup.date().when([], {
      is: () => getFieldObligation('constitutionDate'),
      then: () => yup.date().required(requiredFieldMessage),
      otherwise: () => yup.date(),
    }),
    comercialRegisterNum: yup.string().when([], {
      is: () => getFieldObligation('comercialRegisterNum'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    conservatory: yup.string().when([], {
      is: () => getFieldObligation('conservatory'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    society: yup.string().when([], {
      is: () => getFieldObligation('society'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    otherSociety: yup.string().when([], {
      is: () => getFieldObligation('otherSociety'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    nif: yup.string().when([], {
      is: () => getFieldObligation('nif'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    cae: yup.number('NUMBER').when([], {
      is: () => getFieldObligation('cae'),
      then: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces)
          .required(requiredFieldMessage),
      otherwise: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces),
    }),
    secundaryCae: yup.number('NUMBER').when([], {
      is: () => getFieldObligation('secundaryCae'),
      then: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces)
          .required(requiredFieldMessage),
      otherwise: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces),
    }),
    sectoralCode: yup.string().when([], {
      is: () => getFieldObligation('sectoralCode'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    budgetUnit: yup.string().when([], {
      is: () => getFieldObligation('budgetUnit'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    companyInFormation: yup.string().when([], {
      is: () => getFieldObligation('companyInFormation'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    exportingCompany: yup.string().when([], {
      is: () => getFieldObligation('exportingCompany'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    foreignCapital: yup.string().when([], {
      is: () => getFieldObligation('foreignCapital'),
      then: () =>
        yup
          .string()
          .matches(/^(100|[1-9]?\d)$/, fieldMustBeIntegerPercentage)
          .required(requiredFieldMessage),
      otherwise: () =>
        yup.string().matches(/^(100|[1-9]?\d)$/, fieldMustBeIntegerPercentage),
    }),
    shareCapital: yup.number('NUMBER').when([], {
      is: () => getFieldObligation('shareCapital'),
      then: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces)
          .required(requiredFieldMessage),
      otherwise: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces),
    }),
    currency: yup.string().when([], {
      is: () => getFieldObligation('currency'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    employees: yup.number('NUMBER').when([], {
      is: () => getFieldObligation('employees'),
      then: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces)
          .required(requiredFieldMessage),
      otherwise: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces),
    }),
    salesVolume: yup.number('NUMBER').when([], {
      is: () => getFieldObligation('salesVolume'),
      then: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces)
          .required(requiredFieldMessage),
      otherwise: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces),
    }),
    mainActivity: yup.string().when([], {
      is: () => getFieldObligation('mainActivity'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    secondaryActivity: yup.string().when([], {
      is: () => getFieldObligation('secondaryActivity'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    tertiaryActivity: yup.string().when([], {
      is: () => getFieldObligation('tertiaryActivity'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    operationCountries: yup.string().when([], {
      is: () => getFieldObligation('operationCountries'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    street: yup.string().when([], {
      is: () => getFieldObligation('street'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    secondaryAddress: yup.string().when([], {
      is: () => getFieldObligation('secondaryAddress'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    town: yup.string().when([], {
      is: () => getFieldObligation('town'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    province: yup.string().when([], {
      is: () => getFieldObligation('province'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    postCode: yup.string().when([], {
      is: () => getFieldObligation('postCode'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    country: yup.string().when([], {
      is: () => getFieldObligation('country'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    telephoneNumIndicator: yup.number('NUMBER').when([], {
      is: () => getFieldObligation('telephoneNumIndicator'),
      then: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .required(requiredFieldMessage),
      otherwise: () => yup.number('NUMBER').typeError(fieldMustBeNumber),
    }),
    telephoneNum: yup.number('NUMBER').when([], {
      is: () => getFieldObligation('telephoneNum'),
      then: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces)
          .required(requiredFieldMessage),
      otherwise: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces),
    }),
    telephoneNumDescr: yup.string().when([], {
      is: () => getFieldObligation('telephoneNumDescr'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    phoneNumIndicator: yup.number('NUMBER').when([], {
      is: () => getFieldObligation('phoneNumIndicator'),
      then: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces)
          .required(requiredFieldMessage),
      otherwise: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces),
    }),
    phoneNum: yup.number('NUMBER').when([], {
      is: () => getFieldObligation('phoneNum'),
      then: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces)
          .required(requiredFieldMessage),
      otherwise: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces),
    }),
    phoneNumDescr: yup.string().when([], {
      is: () => getFieldObligation('phoneNumDescr'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    email: yup.string().when([], {
      is: () => getFieldObligation('email'),
      then: () =>
        yup.string().required(requiredFieldMessage).email(fieldMustBeEmail),
      otherwise: () => yup.string().email(fieldMustBeEmail),
    }),
    website: yup.string().when([], {
      is: () => getFieldObligation('website'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    americanCompany: yup.string().when([], {
      is: () => getFieldObligation('americanCompany'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    usTaxId: yup.number('NUMBER').when(['americanCompany'], {
      is: (americanCompany) =>
        americanCompany === 'Y' && getFieldObligation('usTaxId'),
      then: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces)
          .required(requiredFieldMessage),
      otherwise: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces),
    }),
    nonUsFinancialCompany: yup.string().when([], {
      is: () => getFieldObligation('nonUsFinancialCompany'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    giin: yup.number('NUMBER').when([], {
      is: () => getFieldObligation('giin'),
      then: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces)
          .required(requiredFieldMessage),
      otherwise: () =>
        yup
          .number('NUMBER')
          .typeError(fieldMustBeNumber)
          .noSpacesAllowed(fieldCanNotHaveSpaces),
    }),
    usPersonWithVotingRights: yup.string().when([], {
      is: () => getFieldObligation('usPersonWithVotingRights'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    stockExcahangeListedCompany: yup.string().when([], {
      is: () => getFieldObligation('stockExcahangeListedCompany'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    stockExchange: yup.string().when(['stockExcahangeListedCompany'], {
      is: (stockExcahangeListedCompany) =>
        stockExcahangeListedCompany === 'Y' &&
        getFieldObligation('stockExchange'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    financialInstr: yup.string().when([], {
      is: () => getFieldObligation('financialInstr'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    marketOrders: yup.string().when([], {
      is: () => getFieldObligation('marketOrders'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    fundsSource: yup.string().when([], {
      is: () => getFieldObligation('fundsSource'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    businessSource: yup.string().when([], {
      is: () => getFieldObligation('businessSource'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    regDepFinantialInstr: yup.string().when([], {
      is: () => getFieldObligation('regDepFinantialInstr'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    stocks: yup.string().when([], {
      is: () => getFieldObligation('stocks'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    corporateObligations: yup.string().when([], {
      is: () => getFieldObligation('corporateObligations'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    treasuryBonds: yup.string().when([], {
      is: () => getFieldObligation('treasuryBonds'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    treasuryBills: yup.string().when([], {
      is: () => getFieldObligation('treasuryBills'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    collectiveInvestUnits: yup.string().when([], {
      is: () => getFieldObligation('collectiveInvestUnits'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    depositCertificates: yup.string().when([], {
      is: () => getFieldObligation('depositCertificates'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    derivativeInstruments: yup.string().when([], {
      is: () => getFieldObligation('derivativeInstruments'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    structuredProducts: yup.string().when([], {
      is: () => getFieldObligation('structuredProducts'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    commercialPaper: yup.string().when([], {
      is: () => getFieldObligation('commercialPaper'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    ordTransInPerson: yup.string().when([], {
      is: () => getFieldObligation('ordTransInPerson'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    ordTransHasEmail: yup.string().when([], {
      is: () => getFieldObligation('ordTransHasEmail'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
    ordTransEmail: yup.string().when(['ordTransHasEmail'], {
      is: (ordTransHasEmail) =>
        ordTransHasEmail === 'Y' && getFieldObligation('ordTransEmail'),
      then: () =>
        yup.string().required(requiredFieldMessage).email(fieldMustBeEmail),
      otherwise: () => yup.string().email(fieldMustBeEmail),
    }),
    ordTransEmail2: yup.string().when(['ordTransHasEmail'], {
      is: (ordTransHasEmail) =>
        ordTransHasEmail === 'Y' && getFieldObligation('ordTransEmail2'),
      then: () =>
        yup.string().required(requiredFieldMessage).email(fieldMustBeEmail),
      otherwise: () => yup.string().email(fieldMustBeEmail),
    }),
    ordTransPhoneNum: yup.string().when([], {
      is: () => getFieldObligation('ordTransPhoneNum'),
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    }),
  });
};
